// apiService.js
import axios from 'axios';
// axios.defaults.baseURL = 'http://temp.biotrackcapital.com/api/';
// axios.defaults.baseURL = 'http://192.168.55.2:5059/api/';
axios.defaults.baseURL = '/api/';
axios.defaults.timeout = 50000;

// 请求拦截器
axios.interceptors.request.use(
    config => {
        // 添加请求头或其他配置
        const token = localStorage.getItem('userToken');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

// 响应拦截器
axios.interceptors.response.use(
    response => {
        return response.data;
    },
    error => {
        // 处理错误响应
        console.error('API Error:', error);
        return Promise.reject(error);
    }
);

// 定义API请求方法
const ApiService = {
    getData(endpoint, params={}) {
        return axios.get(endpoint, {params});
    },
    postData(endpoint, data) {
        return axios.post(endpoint, data);
    }
};

export default ApiService;
